import { atom } from 'recoil';

export const showCardState = atom<boolean>({
    key: 'show-card-state',
    default: false
});

export const videoTimeLeftState = atom<number>({
    key: 'video-time-left-state',
    default: 0
});

export const videoProgressState = atom<{ timeLeftSeconds: number; playedSeconds: number }>({
    key: 'video-progress-state',
    default: {
        playedSeconds: 0,
        timeLeftSeconds: 0
    }
});
